import { useAuth } from 'hooks/UseAuth'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { FavoritableType, Favorite } from 'api/clients/FavoriteClient'
import { deleteFavorite } from 'redux/actions'
import { WebsocketConsumer } from 'providers/WebsocketProvider'

const CHANNEL_NAME = 'FavoriteChannel'

interface Props {
  websocketConnection: WebsocketConsumer
  favorites: Favorite[]
}

export const useFavoritesChannel = ({ websocketConnection, favorites }: Props) => {
  const [websocketSubscription, setWebsocketSubscription] = useState<any>()
  const auth = useAuth()
  const dispatch = useDispatch()

  const getFavoriteId = (favoritableId: string | number, favoritableType: FavoritableType) => {
    return favorites.find(
      (favorite) => favorite.favoritable_id === favoritableId && favorite.favoritable_type === favoritableType,
    )?.id
  }

  useEffect(() => {
    if (!websocketConnection || !auth) return

    const subscription = websocketConnection.subscriptions.create(
      { channel: CHANNEL_NAME, user_id: auth.id },
      {
        received(payload: any) {
          const { action, favoritable_type, favoritable_id } = payload

          if (action === 'remove') {
            const favoriteId = getFavoriteId(favoritable_id, favoritable_type)
            !!favoriteId && dispatch(deleteFavorite(favoriteId))
          }
        },
      },
    )
    setWebsocketSubscription(subscription)

    return () => {
      subscription.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [websocketConnection])

  return websocketSubscription
}
